import {
  ContractEmailActionType,
  SetContractEmailLoadingAction,
  SetContractEmailListAction
} from 'src/contract/_components/contract-email/contract-email.actions';
import { createReducer } from '@common/redux-utils';
import { EmailNotificationViewModel } from '@models/Contract';

export interface ContractEmailState {
  readonly isLoading: boolean;
  readonly contractEmailList: Array<EmailNotificationViewModel>;
}

export const initContractEmailState: ContractEmailState = {
  isLoading: false,
  contractEmailList: []
};

export function handleSetContractEmailLoading(
  state: ContractEmailState,
  action: SetContractEmailLoadingAction
): ContractEmailState {
  return {
    ...state,
    isLoading: action.isLoading
  };
}

export function handleSetContractEmailList(
  state: ContractEmailState,
  action: SetContractEmailListAction
): ContractEmailState {
  return {
    ...state,
    contractEmailList: action.contractEmailList
  };
}

export const ContractEmailReducer = createReducer<ContractEmailState, ContractEmailActionType>(initContractEmailState, {
  [ContractEmailActionType.SetContractEmailLoading]: handleSetContractEmailLoading,
  [ContractEmailActionType.SetContractEmailList]: handleSetContractEmailList
});



// WEBPACK FOOTER //
// ./src/contract/_components/contract-email/contract-email.reducer.tsx